'use strict';

var React = require('react');
var _ = require('lodash');
var ClassNames = require('classnames');
var FundingYourProductConstants = require('../../constants/FundingYourProductConstants.js');
var FundingYourProductActions = require('../../actions/FundingYourProductActions.js');
var FundingYourProductStore = require('../../stores/FundingYourProductStore.js');
var TextInput = require('../Common/TextInput.jsx');
var SelectInput = require('../Common/SelectInput.jsx');
var InternalRolloverDetails = require('./InternalRolloverDetails.jsx')
var InlineMessage = require('../Common/InlineMessage.jsx');
var ManualEntryId = FundingYourProductConstants.ManualEntryInternalRolloverId;
var Formatter = require('../../utils/Formatter.js');
var Validators = require('../../utils/Validators.js');
var Products = require('../../utils/Products.js');

var InternalRollover = React.createClass({
    getInitialState: function () {
        return {
            showEntireBalanceDetails: false
        };
    },
    handleRadioButton: function (e) {
        if (e.target.checked) {
            var current = this.getCurrentContribution(e);
            FundingYourProductActions.updateInternalAccountDetails({
                isExistingAccount: true,
                productId: current.contribution.id,
                internalAccountIndex: current.contribution.internalAccountIndex,
                rollOverName: current.contribution.accountName,
                accountNumber: current.contribution.accountNumber,
                remainingBalance: current.contribution.accountBalance
            });
            this.setBalanceQuestionVisibility(current.contribution.accountName);
            FundingYourProductActions.setInternalRolloverInfo({
                rolloverIndex: e.target.id,
                showRolloverDetails: e.target.checked,
                showRolloverDetailsNew: false,
                disabledAddProduct: true
            });
        }
    },

    handleAddProduct: function (e) {
        FundingYourProductActions.clearNewFundingType(true);
        this.updateRollover(e.target.name, e.target.id);
        FundingYourProductActions.setInternalRolloverInfo({
            rolloverIndex: e.target.id,
            showRolloverDetails: false,
            showRolloverDetailsNew: e.target.checked,
            disabledAddProduct: false
        });
        this.setState({
            showEntireBalanceDetails:false
        });
    },

    getCurrentContribution: function (e) {
        var objectIndex = e.currentTarget.id;
        var links = objectIndex.split('-');
        var index = '';
        if (Validators.requiredValidation(links[1])) {
            index = links[1];
        }
        if (this.props.inSummary) {
            return { contribution: this.props.data, summaryIndex: index };
        }
        return { contribution: this.props.internalAccounts[index], index: index };
    },

    handleInvestmentVisibility: function (e) {
        var current = this.getCurrentContribution(e);
        var hideInvestments = current.contribution.hideInvestments;

        if (this.props.inSummary) {
            FundingYourProductActions.updateInvestmentVisibility(!hideInvestments, current.summaryIndex);
        }
        else {
            FundingYourProductActions.updateInvestmentVisibility(!hideInvestments, current.index, true);
        }
    },

    updateInternalRollover: function (e) {
        this.updateRollover(e.target.model, e.target.value);
    },

    updateRollover: function (model, value) {
        if (this.props.inSummary) {
            FundingYourProductActions.updateExistingRollover(model, value, FundingYourProductConstants.RollOverTypes.INTERNAL, this.props.index);
        } else {
            FundingYourProductActions.updateNewRollover(model, value, FundingYourProductConstants.RollOverTypes.INTERNAL);
        }
    },

    setBalanceQuestionVisibility: function (productName) {
        var isSuper = _.find(FundingYourProductConstants.SuperProducts, { value: productName });
        this.setState({ showEntireBalanceDetails: isSuper ?true:false });
    },

    handleSelectProduct: function (e) {
        this.setBalanceQuestionVisibility(e.target.value);
        this.updateInternalRollover(e);
        this.getProductIdByValue(e.target.value);
    },

    getProductIdByValue: function (productName) {
        var searchParam = Products.isInvestment(this.props.product) ? FundingYourProductConstants.InvestmentProducts : FundingYourProductConstants.PensionAndSuperProducts;
        var result = _.find(searchParam, { 'value': productName });
        if (result) {
            this.updateRollover(FundingYourProductConstants.selectedProductIdText, result.id);
        }
    },

    cancelEditMode: function () {
        FundingYourProductActions.setInternalRolloverInfo({
            rolloverIndex: '',
            showRolloverDetails: false,
            showRolloverDetailsNew: false,
            disabledAddProduct: true
        });
        this.setState({ showEntireBalanceDetails: false });
        if (Products.isInvestment(this.props.product)) {
            this.props.onCancelClick();
        } else {
            FundingYourProductActions.setActiveFundType('');
            FundingYourProductActions.toggleFundingTypeVisibility();
        }
    },

    finishEditMode: function () {
        if (Products.isInvestment(this.props.product)) {
            this.props.onDoneClick();
        } else {
            FundingYourProductActions.submitInternalRollover();
        }
        if (this.props.data.errorList.length === 0) {
            FundingYourProductActions.setInternalRolloverInfo({
                rolloverIndex: '',
                showRolloverDetails: false,
                showRolloverDetailsNew: false,
                disabledAddProduct: true
            });
            this.setState({ showEntireBalanceDetails: false });
        }

    },

    render: function () {       
        var manualEntryId = ManualEntryId;
        var data = this.props.data;
        var index = this.props.index;
        var product = this.props.product;
        var content = this.props.content;
        var inSummary = this.props.inSummary;
        var rolloverIndex = this.props.internalRolloverInfo.rolloverIndex;
        var showRolloverDetails = this.props.internalRolloverInfo.showRolloverDetails;
        var showRolloverDetailsNew = this.props.internalRolloverInfo.showRolloverDetailsNew;
        var disabledAddProduct = this.props.internalRolloverInfo.disabledAddProduct;
        var showEntireBalanceDetails = this.state.showEntireBalanceDetails;
        var cancelEditMode = this.props.inSummary ? this.props.onCancelClick : this.cancelEditMode;
        var finishEditMode = this.props.inSummary ? this.props.onDoneClick : this.finishEditMode;               
        var handleInvestmentVisibility = this.handleInvestmentVisibility;
        var handleRadioButton = this.handleRadioButton;      
        var selectProductOptions = Products.isInvestment(this.props.product) ? FundingYourProductConstants.InvestmentProducts : FundingYourProductConstants.PensionAndSuperProducts;
        var investmentOptionsClass = inSummary ? 'isEditInvestment investment-detail' : 'investment-detail';
        var investmentOptionsLinkClass = inSummary ? 'isEditInvestment investment-hide-link' : 'investment-hide-link';
        var showExistingAccounts = !FundingYourProductStore.getIsDeathBenefit();
        var renderInvestmentRow = function (contributions, index) {
            return (
                <div className={investmentOptionsClass} key={index }>- {contributions.name}: ${contributions.balance}</div>
            );
        };
        var renderInvestments = function (contributions, index) {
            var showInvestmentId = 'showInvestment-' + index,
                hideInvestmentId = 'hideInvestment-' + index;
            var investments = '';
            if (contributions.investmentOptions.length > 0) {
                investments = <div className="col-md-12 investment-visibility">
                         <div className={ClassNames({ hidden: contributions.hideInvestments })}>
                             {contributions.investmentOptions.map(function (contributions, index) {
                                 return (renderInvestmentRow(contributions, index));
                             })}
                             <div className={investmentOptionsLinkClass}>
                                <a id={hideInvestmentId} onClick={handleInvestmentVisibility}>Hide Investments</a>
                             </div>
                         </div>
                        <div className={ClassNames(investmentOptionsLinkClass, { hidden: !contributions.hideInvestments })}>
                            <a id={showInvestmentId} onClick={handleInvestmentVisibility}>Show Investments</a>
                        </div>
                </div>;
            }
            return investments;
        };
        var renderInternalRolloverDetails = function (index) {
            var rolloverDetails = '';
            if (rolloverIndex === 'fypInternalRolloverProduct-' + index) {
                rolloverDetails = <div id={'fypInternalRolloverProduct-' + index}>
                    <InternalRolloverDetails showRolloverDetails={showRolloverDetails}
                                             rolloverIndex={index}
                                             product={product}
                                             data={data}
                                             index={index}
                                             showEntireBalanceDetails={showEntireBalanceDetails}
                                             content={content}
                                             onCancelClick={cancelEditMode}
                                             onDoneClick={finishEditMode} />
                </div>;
            }
            return rolloverDetails;
        };

        var internalRollover = function (contributions, index) {
            return (
                <tr key={index}>
                        <td className="existing-account" colSpan="3">
                                <div className="col-md-5 form-select form-inline">
                                    <input id={'fypInternalRolloverProduct-' + index} type="radio" name="productId" value={data.productId} checked={rolloverIndex === 'fypInternalRolloverProduct-' + index} onChange={handleRadioButton} />
                                    <label htmlFor={'fypInternalRolloverProduct-' + index} className={ClassNames('btn-option-label', { hidden: inSummary })}><i className="icon icon-check"></i></label>
                                    <span>{contributions.accountName}</span>
                                </div>
                                <div className="col-md-3">{contributions.accountNumber}</div>
                                <div className="col-md-3">$ {contributions.accountBalance}</div>
                            {renderInvestments(contributions, index)}
                            {renderInternalRolloverDetails(index)}
                        </td>
                </tr>
            );
        }

        var manualEntryErrors = [];
        var invalidProduct = false, invalidAccountNumber = false, invalidBalance = false;
        if (this.props.data) {
            var productInternalRolloverError = _.filter(this.props.data.errorList, { id: 'fypProductInternalRollover' });
            if (productInternalRolloverError.length > 0) {
                manualEntryErrors = manualEntryErrors.concat(productInternalRolloverError);
                invalidProduct = true;
            } else {
                Formatter.removeError(manualEntryErrors, 'fypProductInternalRollover');
                invalidProduct = false;
            }
            var accountNumberError = _.filter(this.props.data.errorList, { id: 'fypInternalRolloverAccountNumber' });
            if (accountNumberError.length > 0) {
                manualEntryErrors = manualEntryErrors.concat(accountNumberError);
                invalidAccountNumber = true;
            } else {
                Formatter.removeError(manualEntryErrors, 'fypInternalRolloverAccountNumber');
                invalidAccountNumber = false;
            }
            var remainingBalance = _.filter(this.props.data.errorList, { id: 'fypInternalRolloverRemainingBalance' });
            if (remainingBalance.length > 0) {
                manualEntryErrors = manualEntryErrors.concat(remainingBalance);
                invalidBalance = true;
            } else {
                Formatter.removeError(manualEntryErrors, 'fypInternalRolloverRemainingBalance');
                invalidBalance = false;
            }
        }

        var inlineError = function (data, index) {
            return (<InlineMessage id={data.id} key={index} isHidden={false} type="error" message={data.message } />);
        };
        var addProduct = <tr className="add-product-section">
                    <td colSpan="3" className="col-md-12 add-product-select">
                        <div className="col-md-5 form-select">
                            <div className={ClassNames({ hidden: inSummary })}>
                                <input tabIndex="-1" id={manualEntryId} model="productId" type="radio" name="productId" value={this.props.data.productId} checked={rolloverIndex === manualEntryId} onChange={this.handleAddProduct} />
                                <label tabIndex="0" htmlFor="addProduct0" className="btn-option-label"><i className="icon icon-check"></i></label>
                            </div>
                            <SelectInput id="fypProductInternalRollover"
                                         options={selectProductOptions}
                                         customClass="col-md-10 account-number"
                                         model="rollOverName"
                                         searchable={false}
                                         clearable={false}
                                         tabIndex="0"
                                         hasWarning={invalidProduct}
                                         value={this.props.data.productId === manualEntryId ? this.props.data.rollOverName : ''}
                                         onChange={this.handleSelectProduct}
                                         disabled={disabledAddProduct} />
                        </div>
                        <div className="col-md-3">
                            <TextInput id="fypInternalRolloverAccountNumber"
                                       model="accountNumber"
                                       customClass="add-product-text-input"
                                       value={this.props.data.productId === manualEntryId ? this.props.data.accountNumber : ''}
                                       onBlur={this.updateInternalRollover}
                                       hasWarning={invalidAccountNumber}
                                       isDisabled={disabledAddProduct} />
                        </div>
                        <div className="col-md-3">
                            <TextInput id="fypInternalRolloverRemainingBalance"
                                       model="remainingBalance"
                                       symbol="currency"
                                       customClass="add-product-text-input"
                                       value={this.props.data.productId === manualEntryId ? this.props.data.remainingBalance : ''}
                                       onBlur={this.updateInternalRollover}
                                       hasWarning={invalidBalance}
                                       isDisabled={disabledAddProduct} />
                        </div>
                    </td>

        </tr>;
        var inlineErrors = function () {
            if (manualEntryErrors.length > 0) {
                return <tr>
                            <td colSpan="3">
                                { (manualEntryErrors).map(inlineError) }
                            </td>
                </tr>;
            } else {
                return null;
            }
        }
        var renderNewInternalRollover = function () {
            if (showRolloverDetailsNew === true) {
                return <tr className="add-new-product">
                        <td colSpan="3">
                            <div id="newProduct">
                                <InternalRolloverDetails showRolloverDetails={showRolloverDetailsNew}
                                                         rolloverIndex={-1}
                                                         index={index}
                                                         product={product}
                                                         data={data}
                                                         content={content}
                                                         showEntireBalanceDetails={showEntireBalanceDetails}
                                                         onCancelClick={cancelEditMode}
                                                         onDoneClick={finishEditMode}
                                                         inSummary={inSummary} />
                            </div>
                        </td>
                </tr>;
            } else {
                return null;
            }
        }
        var existingAccounts;
        
        if (inSummary) {
            if (data.isExistingAccount) {
                var contributions = _.cloneDeep(data);
                addProduct = <tr></tr>;
                contributions.accountName = data.rollOverName;
                contributions.accountNumber = data.accountNumber;
                contributions.accountBalance = data.remainingBalance;
                contributions.hideInvestments = data.hideInvestments;
                existingAccounts = internalRollover(contributions, index);
            }
            else {
                existingAccounts = <tr></tr>;
            }
        }
        else if (!showExistingAccounts) {
            existingAccounts = <tr></tr>;
        }
        else {
            existingAccounts = this.props.internalAccounts.map(internalRollover, this);
        }
        
        var hideInternalRollover = true;
        if (Products.isInvestment(this.props.product)) {
            if (this.props.data.paymentMethod === FundingYourProductConstants.ContributionValues.INTERNAL_TRANSFER) {
                hideInternalRollover = false;
            }
        } else {
            if (this.props.activeFundType === FundingYourProductConstants.FundingTypes.Internal_rollover) {
                hideInternalRollover = false;
            }
        }

        return (
                <div id="fundingYourProductInternalRollover" className={ClassNames('row', { hidden: hideInternalRollover })}>
                    <div className="col-md-12 internal-rollover-div">
                        <table className="table table-single">
                            <thead>
                                <tr className="add-product-select">
                                    <td className="column-heading col-md-5">PRODUCT<span className="hidden-xs"></span></td>
                                    <td className="column-heading col-md-3"><span className="hidden-xs">ACCOUNT NUMBER</span></td>
                                    <td className="column-heading col-md-3"><span>APPROXIMATE BALANCE</span></td>
                                </tr>
                            </thead>
                            <tbody className="internal-rollover-body">
                                {existingAccounts}
                                {addProduct}
                                {inlineErrors()}
                                {renderNewInternalRollover()}
                            </tbody>
                        </table>
                    </div>
                </div>
        );
    }
});

module.exports = InternalRollover;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/FundingYourProduct/InternalRollover.jsx